<template>
  <div class="HSDetail">
    <div v-if="loading" @touchmove.prevent class="loadingBox">
      <div class="loader">
          <div class="orbe" style="--index: 0"></div>
          <div class="orbe" style="--index: 1"></div>
          <div class="orbe" style="--index: 2"></div>
          <div class="orbe" style="--index: 3"></div>
          <div class="orbe" style="--index: 4"></div>
      </div>
    </div>
    <div v-if="!loading" class="hsd_nr">
      <img class="backBtn" src="@/assets/img/back2x.png" alt="" @click="go_back()">
      <div ref="header" v-show="showTopNav" :style="'opacity:' + opacity" class="header acea-row row-center-wrapper">
        <div class="search_nav">
          <img class="go_back" src="@/assets/back_black.png" alt @click="go_back()">
          <div class="book_name">{{lesson_name}}</div>
          <!-- <div class="s_inp">
            <img src="@/assets/icon_search.png" alt="">
            <form action="javascript:return true">
              <input v-model="keywords" type="search" placeholder="搜索产品" @focus="focus_ipt()">
            </form>
          </div> -->
        </div>
        <div class="top_nav">
          <div
          v-for="(item, index) in navList"
          :class="navActive === index ? 'on' : ''"
          :key="index"
          class="item"
          @click="asideTap(index)"
        >{{ item }}</div>
        </div>
        
      </div>
      <!-- vant的轮番图 -->
      <div ref="anhorTop" id="title0" class="detail_swipe anhorTop">
        <van-swipe :autoplay="3000" class="swipe" indicator-color="white" @change="checkActive">
          <van-swipe-item v-for="(item,index) in productImg" :key="index">
            <img :src="item" alt="">
          </van-swipe-item>
          <template slot="indicator" >
                <ul v-if="false" class="indicators indicator">
                  <li :class="key==current?'active':''" v-for="(val, key) in productImg" :key="key"></li>
                </ul>
            </template>
        </van-swipe>
      </div>
      <!-- <div v-for="(val, index) in list" :ref="val.key" :key="index" class="content">
        <p :id="'title'+(1+index)">{{ val.name }}</p>
        <ul>
          <li v-for="item in 30" :key="item">内容：{{ index + 1 }}</li>
        </ul>
      </div> -->
      <div  class="content">
        <!-- 限时折扣样式 -->
        <!-- lesson_sku_type==1 -->
        <!-- isZhekou -->
        <div v-if="false" class="discountBox">
          <div class="activity_left">限时折扣</div>
          <div class="activity_right">
            <div class="activity_time">距离{{ preorbegin?'开始':'结束' }}还有</div>
            <div v-if="zhekouDay!=0" class="days time">{{ zhekouDay }}</div>
            <div v-if="zhekouDay!=0" class="symbol day">天</div>
            <div class="hours time">{{ zhekouHours }}</div>
            <div class="symbol">小时</div>
            <div class="mins time">{{ zhekouMins }}</div>
            <div class="symbol">分</div>
            <div class="secs time">{{ zhekouSecs }}</div>
            <div class="symbol">秒</div>
          </div>
        </div>
        <!-- 拼团 -->
        <!-- v-if="lesson_sku_type==2" -->
        <!-- is_groupon -->
        <div v-if="false" class="activity_box">
          <div class="activity_left">
            <span class="activity_title">拼团</span>
          </div>
          <div class="activity_right">
            <div class="activity_time">距离结束还有</div>
            <!--  -->
            <div v-if="groupDay!=0" class="days time">{{ groupDay }}</div>
            <div v-if="groupDay!=0" class="symbol day">天</div>
            <div class="hours time">{{ groupHours }}</div>
            <div class="symbol">小时</div>
            <div class="mins time">{{ groupMins }}</div>
            <div class="symbol">分</div>
            <div class="secs time">{{ groupSecs }}</div>
            <div class="symbol">秒</div>
          </div>
        </div>
        <!-- 商品价格信息 -->
        <!-- 商品价格 -->
        <div class="product_info">
          <div class="selling_price">
            <span class="unit">￥</span>
            <span class="money number">{{ bottom_price }}</span>
          </div>
          <!-- vip价格 -->
          <div v-if="vip_discount!=''&&vip_discount!=100" class="price_bottom">
              <div class="discount_price vip_discount_price">
                <span class="unit">￥</span>
                <span class="money">{{ vip_bottom_price }}</span>
              </div>
              <!-- 商品会员折扣 -->
              <div class="vip"  @click="go_vip">
                <div class="vip_status">
                  <div class="is_vip">VIP</div>
                  <div class="discount">
                    {{ vip_discount/10 }}折
                  </div>
                </div>
              </div>
          </div>
          <div class="product_name">
             {{lesson_name}}
          </div>
        </div>
      </div>
      <div  ref="anhorTop"  class="content anhorTop">
        <!-- <p  id="title1">评论</p> -->
        <div id="title1">
          <!-- 评论 -->
          <div class="cell"  @click="go_allComment">
            <div class="cell_left">
              <span>评论</span>
              <span class="cell_num">（{{comment_num}}）</span>
            </div>
            <div class="cell_right">
              <span class="feedback">{{info_comment_rate}}%好评率</span>
              <van-icon class="arrow-icon" name="arrow" />
            </div>
          </div>
          <div class="assess">
            <div v-for="(item, index) in pjlist" v-show="pjlist.length > 0" :key="index" class="assess-msg">
              <div class="attrTag">
                <div class="attr_item" v-for="(val,key) in item.attr" :key="key">{{val}}</div>
              </div>
              <div class="nick">
                <div class="nick-img">
                  <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt>
                </div>
                <div id="nick" class="nick-name">
                  <p>
                    <span>{{ item.username }}</span>
                    <!-- <span style="color: #999; float: right">{{ sli(item.create_time) }}</span> -->
                  </p>
                </div>
              </div>
              <p  class="comment_content" v-html="item.content.replace(/<img.*?>/g, '')"></p>
            </div>
            <div v-show="pjlist.length == 0" class="emptyBox">
              <img src="@/assets/new_kong.png" alt>
              <p v-if="isLogin">暂无评论~</p>
              <p v-else>登录查看评论~</p>
            </div>
          </div>

          <!-- 问大家 -->
          <div class="cell" @click="go_allQa">
            <div class="cell_left">
              <span>问大家</span>
              <span class="cell_num">（{{QaCount}}）</span>
            </div>
            <div class="cell_right">
              <van-icon class="arrow-icon" name="arrow" />
            </div>
          </div>
          <div class="qaBox">
            <div v-for="(item, index) in QaList" v-show="QaList.length > 0" :key="index" class="qa-msg">
              <div class="qa_item">
                <span class="text">问</span>
                <p   class="qa_content" v-html="item.content"></p>
              </div>
              <div class="qa_num">
                {{item.count}}个回答
              </div>
            </div>
            <div v-show="QaList.length == 0" class="emptyBox">
              <img src="@/assets/new_kong.png" alt>
              <p v-if="isLogin">暂无提问~</p>
              <p v-else>登录查看提问~</p>
            </div>
          </div>
        </div>
      </div>
      <div  ref="anhorTop"  class="content anhorTop">
        <p id="title2" class="itemTitle"><span class="line">————</span> 宝贝详情 <span class="line">————</span>
        </p>
        <p v-show="info" class="lesson-info" v-html="info"></p>
        <div v-show="info == ''" class="emptyBox">
          <img src="@/assets/new_kong.png" alt>
          <p>暂无详情~</p>
        </div>
      </div>
      <!-- <div  ref="anhorTop"  class="content anhorTop">
        <p id="title3" class="itemTitle"><span class="line">————</span> 相关推荐 <span class="line">————</span></p>
        <div v-if="recommendList.length" class="recommendBox">
          <div v-for="(item,index) in recommendList" :key="index" class="recommendItem">
            <div class="imgBox">
              <div class="img">
                <img :src="item.thumb" alt="">
              </div>
            </div>
            <div class="product_name">
              {{item.lesson_name}}
            </div>
            <div class="product_price">
              <span>￥</span>
              <span class="price">{{item.price}}</span>起
            </div>
          </div>
        </div>
        <div v-show="recommendList.length == 0" class="emptyBox">
          <img src="@/assets/new_kong.png" alt>
          <p>暂无相关推荐~</p>
        </div>
      </div> -->
      <!-- 底部菜单栏 -->
      <div class="bot_nav">
        <div class="bot_left">
          <div class="left-advice" @click="consultTeacher">
            <img src="../../assets/myicon/ffhf.png" class="iv_sc11" alt>
            <p>客服</p>
          </div>
          <!-- <div class="right-like" @click="shoucangFun()">
            <img v-if="is_favorite === 1 && isLogin" class="iv_sc" src="../../assets/myicon/red_star.png" alt>
            <img v-else class="iv_sc" src="../../assets/myicon/gray_star.png" alt>
            <div >
              <p v-show="!is_favorite" class="tv_sc">收藏</p>
              <p v-show="is_favorite" class="tv_sc" style="color: #f02c2d">
                收藏
              </p>
            </div>
          </div> -->
        </div>
        <div class="bot_right">
          <div v-if="product_num>0&&num<=product_num" class="goBuy" @click="goBuy">
            立即购买
          </div>
          <div v-if="!product_num||num>product_num" class="have_none">暂无库存</div>
        </div>
      </div>
    </div>
    <van-action-sheet :round="true" v-model:show="selectSku">
      <div class="mainContent">
          <van-icon @click="closeSelect" class="icon-close" name="close" />
          <div class="top_product">
            <div class="product_left">
              <img :src="bigImg" alt="">
            </div>
            <div class="product_right">
              <!-- 不是销售策略的价格 -->
              <div v-if="!isStrategy1" class="product_price">
                <p>
                  <span class="unit">￥</span>
                  <span class="price">{{productPrice}}</span>
                </p>
                <!-- vip折扣 -->
                <template>
                  <div v-if="vip_discount!=''&&vip_discount!=100" class="price_bottom">
                    <div class="vip_discount_price">
                      <span class="unit">￥</span>
                      <span class="money">{{ productVipPrice }}</span>
                    </div>
                    <div class="vip"  @click="go_vip">
                      <div class="vip_status">
                        <div class="is_vip">VIP</div>
                        <div class="discount">
                          {{ vip_discount/10 }}折
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <!-- 销售策略价格 -->
              <div v-if="isStrategy1" class="product_price">
                <p>
                  <span class="unit">￥</span>
                  <span class="price">{{ strategy_price }}</span>
                </p>
                <!-- vip折扣 -->
                <template>
                  <div v-if="vip_discount!=''&&vip_discount!=100" class="price_bottom">
                    <div class="vip_discount_price">
                      <span class="unit">￥</span>
                      <span class="money">{{ vip_strategy_price }}</span>
                    </div>
                    <div class="vip"  @click="go_vip">
                      <div class="vip_status">
                        <div class="is_vip">VIP</div>
                        <div class="discount">
                          {{ vip_discount/10 }}折
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <!-- 限时折扣已经开始或者有拼团 -->
              <p v-if="(isZhekou&&!preorbegin)||is_groupon" class="discount_price">
                <span>限时折扣</span>
                <span class="unit">￥</span>
                <span class="price">{{ promotionPrice }}</span>
              </p>
              <!-- <p class="other_info">
                重量: 1.558kg
              </p> -->
            </div>
          </div>
          <div class="product_sku">
            <!-- 商品规格 -->
            <!-- <div v-for="(item,index) in spec_list" :key="index" class="specification">
              <div class="title">{{ item.name }}</div>
              <div class="specification_list">
                <div v-for="(val,key) in item.value" :key="key" class="specification_item" @click="chooseSpecification(item,index,val,key)">
                  <div v-if="index==1&&defaultProductId[index]==val.spec_value_id&&(isZhekou&&!preorbegin)" class="product_status">惠</div>
                  <div v-else-if="index==0&&defaultProductId[index]==val.spec_value_id&&(isZhekou&&!preorbegin)" class="product_status">惠</div>
                  <div v-if="index==1&&defaultProductId[index]==val.spec_value_id&&is_groupon" class="product_status">拼</div>
                  <div v-else-if="index==0&&defaultProductId[index]==val.spec_value_id&&is_groupon" class="product_status">拼</div>
                  <div class="item" :class="[defaultProductId[index]==val.spec_value_id?'on':'',index==val.disablePosition&&val.spec_value_id==val.disableSpecificationId?'disable':'']">
                    <span>{{ val.value_name }}</span>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- 商品信息 -->
            <div class="product_desc">
              <div class="row">
                <div>ISBN编号：{{isbn_number}} </div>
                <div>作者：{{author_name}}</div>
              </div>
              <div class="row">
                <div>出版社名称：{{publishing_house}}</div>
                <div>出版时间：{{publishing_time}}</div>
              </div>
              <div class="row">
                <div>开本：{{pages_sum}}开</div>
              </div>
            </div>
            <div class="product_pack" v-if="isStrategy1">
              <div class="title">选择套餐</div>
              <div class="mySpans">
                <span v-for="(item,index) in isStrategy" :key="index" :class="{'span1':index === mySpanIndex}" @click="clickMySpan(index,item.id)">{{ item.strategy_name }}</span>
              </div>
            </div>
            <div class="product_num">
              <div class="title">数量</div>
              <van-stepper v-model="num" min="1" :max="maxNum" @change="handleChange"/>
            </div>
          </div>
          <!-- 没有销售策略 -->
          <div v-if="!isStrategy1" class="toBuy" @click="goToPay">
            立即购买￥
            {{vip_level==2?productVipPrice:productPrice}}
          </div>
          <!-- 有销售策略 -->
          <div v-if="isStrategy1" class="toBuy" @click="goToPay">
            立即购买￥
            {{vip_level==2?vip_strategy_price:strategy_price}}
            <!-- {{ strategy_price }} -->
          </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { math } from '@/utils/math.js'
import tool from '@/utils/tools.js'
import { 
  getTextbook,
  get_evaluate, 
  QaAll,
  lessonRecommendList,
  collectLesson,
  getCollectByUid,
  getLessonSpecPrice,
  getBuyCheck,
  getBookStategyById
} from '@/api/book.js'
export default {
  name: 'HSDetail',
  components: {},
  inject: ['reload'],
  data() {
    return {
      showBase: false,
      isLogin: false,//登录状态
      navList: ['宝贝','评论', '详情'],
      opacity: 0,
      navActive: 0,
      page_url:'',
      keywords:'',
      book_id: this.$route.query.book_id,
      biaoList: ['男-惊讶', '男-流泪', '男-害羞', '男-闭嘴', '男-睡', '男-发怒', '男-得意', '男-抓狂', '男-吐', '男-偷笑', '男-困', '男-流汗', '男-咒骂', '男-疑问', '男-嘘', '男-晕', '男-衰', '男-再见', '男-猪头', '男-拥抱', '男-爱心', '男-心碎', '男-强', '男-弱', '男-抠鼻', '男-鼓掌', '男-左哼哼', '男-右哼哼', '男-哈欠', '男-鄙视', '男-委屈', '男-阴险', '男-亲亲', '男-可怜', '男-勾引', '男-NO', '男-OK', '男-爱你', '男-蛋糕', '男-给力', '男-哈哈', '男-大哈哈', '男-蜡烛', '男-礼物', '男-胜利'],
      strMap: {},
      lesson_name:'',//商品名称
      bottom_price:0,//商品价格
      vip_bottom_price:0,//商品价格
      // 收藏状态
      is_favorite: 0,
      // loading
      loading:false,//页面加载动画
      productImg: [],
      current:0,
      info:'',//商品详情
      anhorList:[],
      pjlist:[],//评论列表
      comment_num:0,//评论条数
      QaList: [],//问答列表
      QaCount: 0,//问答条数
      recommendList:[],//推荐产品
      vip_discount:100, // vip折扣
      info_buy_count: 0, // 购买人数
      info_comment_rate: 0, // 好评率
      product_id: '', // 选中产品id
      package_id: '', // 选中套餐id
      specificationIndex: 0, // 规格索引
      packageIndex: '', // 套餐索引
      // productArr: [], // 商品规格
      spec_list: [], // 商品规格
      spec_sku: [], // 规格对应信息
      packageArr: [], // 商品套餐
      num: Number(this.$route.query.num) || 1, // 产品购买数量
      // 限时折扣
      isZhekou: false, // 是否打折
      surplusTime: 0, // 折扣结束时间
      zhekouDay: 0, // 折扣天数
      zhekouHours: 0, // 折扣小时
      zhekouMins: 0, // 折扣分钟
      zhekouSecs: 0, // 折扣秒
      preorbegin: false, // 开始or结束  true显示开始 false显示结束
      lessonSpecPrice: 0, // 产品单价
      productPrice: 0, // 产品价格
      productVipPrice: 0, // 会员价格
      promotionPrice: 0, // 促销价
      promotion_price: 100, // 促销折扣
      promotion_rate: 100, // 折扣百分比
      // 拼团
      is_groupon: 0, // 是否显示拼团
      persents: 100, // 拼团折扣
      groupTimer: null, // 拼团倒计时
      groupDay: 0, // 拼团折扣天数
      groupHours: 0, // 拼团折扣小时
      groupMins: 0, // 拼团折扣分钟
      groupSecs: 0, // 拼团折扣秒
      uid: '',
      selectSku:false,//规格弹出窗
      maxNum: 100, // 最大可购数量
      recommend: [], // 推荐产品
      // 默认选中有库存规格的产品id
      defaultProductId: [],
      check_lesson_sku_str: this.$route.query.spec_sku_id || '', // 选中规格的产品sku
      check_lesson_sku_id: this.$route.query.lesson_sku_id || '', // 选中规格的产品sku 的id
      // 克隆的规格及sku列表用于重置数据
      copy_spec_list: [],
      copy_spec_sku: [],
      left_nav: [],
      bigImg:'',
      vip_level:0,
      default_check_id:'',
      lesson_sku_type:0,//  1  促销 2拼团 0 没有 
      // 销售策略
      isStrategy: [],
      mySpanIndex: 0,
      mySpanMsg: null,
      isStrategy1: false,
      isPopup: false,
      ad_banner: [],
      original_price: '',
      strategy_price: '',
      vip_strategy_price:'',//销售策略vip叠加价格
      // 销售策略单价
      original_price_: '',
      strategy_price_: '',
      vip_strategy_price_:'',

      discount_price: '',
      groupon_price: '',
      groupon_price_s: false,
      // 图书信息
      isbn_number:'',
      author_name:'',
      pages_sum:'',
      publishing_house:'',
      publishing_time:'',
      product_num:1,
      im_url:''
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var url = window.location.href
    this.page_url = encodeURIComponent(url)
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    const uid = Cookies.get('uid')
    if (uid) {
      this.isLogin = true
    }
    // 表情回显
    this.biaoList.forEach((item, index) => {
      if (index < 9) {
        this.strMap[index] = '<img src=' + require('@/assets/lan/0' + (index + 1) + '.gif') + '>'
      } else {
        this.strMap[index] = '<img src=' + require('@/assets/lan/' + (index + 1) + '.gif') + '>'
      }
    })
    window.addEventListener('scroll', this.handleScroll)
    this.getFun()
    this.getpl()
    this.getQa()
    // this.getRecomment()
  },
  computed:{
    showTopNav:{
      get() { 
        return Boolean(this.opacity)
      },
      set(newValue) {
        console.log('newValue', newValue)
      }
    }
  },
  // 方法集合
  methods: {
    clickMySpan(index, id) {
      this.mySpanIndex = index
      this.mySpanMsg = id

      getBookStategyById({ id }).then((res) => {
        // console.log(res, '销售策略')
        this.ad_banner = res.result.list
        this.original_price_ = res.result.price
        this.strategy_price_ = res.result.strategy_price
        this.vip_strategy_price_ = math.multiply(res.result.strategy_price,this.vip_discount/100)
        this.original_price = math.multiply(res.result.price,this.num)
        this.strategy_price = math.multiply(res.result.strategy_price,this.num)
        this.vip_strategy_price = math.multiply(this.vip_strategy_price_,this.num)
      })
    },
    // 销售策略
    getStategy() {
      this.mySpanIndex = 0
      this.ad_banner = []
      var info = {
        id: this.isStrategy[0].id
      }
      getBookStategyById(info).then((res) => {
        // console.log(res, '销售策略')
        this.ad_banner = res.result.list
        this.original_price_ = res.result.price
        this.strategy_price_ = res.result.strategy_price
        this.vip_strategy_price_ = math.multiply(res.result.strategy_price,this.vip_discount/100)
        this.original_price = math.multiply(res.result.price,this.num)
        this.strategy_price = math.multiply(res.result.strategy_price,this.num)
        this.vip_strategy_price = math.multiply(this.vip_strategy_price_,this.num)
      })
    },
    // 弹窗购买
    goToPay(){
      // 先判断登录状态
      if (this.isToLogin()) {
        if(this.num>this.product_num){
          return this.$toast('库存不足')
        }else{
          if(this.mySpanMsg){
            location.href = window.origin+`/shop/pay/?product_type=${7}&product_id=${this.mySpanMsg}&product_num=${this.num}&fromurl=${this.page_url}&f_code=${''}`
          }else{
            location.href = window.origin + `/shop/pay/?product_type=${15}&product_id=${this.book_id}&product_num=${this.num}&fromurl=${this.page_url}&f_code=${''}`
          }
        }
        
      //   var info = {
      //       lesson_id: this.lesson_id,
      //       num: this.num,
      //       product_id: this.check_lesson_sku_id
      //     }
      //   getBuyCheck(info).then((res) => {
      //     if (res.errNo == 0) {
      //       if(this.is_groupon){
      //       // 跳转拼团页面
      //         this.$router.push({
      //           path:'/group_work',
      //           query:{
      //             lesson_id:this.lesson_id,
      //             product_id: this.check_lesson_sku_id,
      //             num: this.num
      //           }
      //         })
      //       }else{
      //         // 跳转购买页面
      //         var info = {
      //           lesson_id: this.lesson_id,
      //           num: this.num,
      //           product_id: this.check_lesson_sku_id
      //           // package_id: this.package_id
      //         }
      //         var target = this.$router.resolve({
      //           path: '/shop/pay',
      //           query: {
      //             product_type: 1,
      //             product_id: this.lesson_id,
      //             // package_id: this.package_id,
      //             specification_id: this.check_lesson_sku_id,
      //             num: this.num,
      //             fromurl: `${this.page_url}`
      //           }
      //         })
      //         location.href = target.href
      //       }
      //     }else{
      //       this.$toast(res.msg)
      //     }
      // })
        
      }
      
    },
    // 选择规格
    chooseSpecification(item, index, val, key) {
      console.log(item, index, val, key, '切换规格')
      // 如果没有在禁用状态下
      this.isZhekou = false
      this.is_groupon = false
      if (!val.disablePosition && val.disablePosition != 0) {
        this.maxNum = 100// 重置可购数量
        // // 高亮显示产品规格
        this.defaultProductId[index] = val.spec_value_id.toString()
        // console.log(this.defaultProductId)
        this.getCorrelation(this.defaultProductId, JSON.parse(JSON.stringify(this.copy_spec_sku)))
        // this.getProductInfo(val.lesson_sku_id)
        // 查找所选规格对应的sku信息
        var productItem = this.getSpecInfo(this.defaultProductId.join('_'))
        // 获取产品价格折扣等信息
        this.getProductInfo(productItem.lesson_sku_id)
      }
    },
    // 根据所选规格查找对应产品规格信息
    getSpecInfo(spec) { // 传入规格值 1_5_7
      for (let i = 0; i < this.spec_sku.length; i++) {
        if (this.spec_sku[i].spec_sku_id == spec) {
          return this.spec_sku[i]
        }
      }
    },
    // 收藏
    async shoucangFun() {
      const data = {
        lesson_id: this.lesson_id
      }
      collectLesson(data).then((res) => {
        if (res.errNo == 0) {
          // return this.$message.error(res.msg)
          this.$toast(res.msg)
          this.getCollectStatus()
          this.collectMsg = res.msg
          this.is_favorite = !this.is_favorite
        }  
      })
      // const res = await collectLesson(data)
    },
    // 当前课程是否已经收藏
    getCollectStatus() {
      var info = {
        lesson_id: this.lesson_id
      }
      getCollectByUid(info).then((res) => {
        // if (res.result == 1) {
        this.is_favorite = res.result
        // }
      })
    },
    // 商品购买数量
    handleChange(num) {
      this.num = num
      this.getProductPrice(Number(this.lessonSpecPrice), this.num, this.promotion_rate, this.grouponPrice)
      if(this.isStrategy1){
        this.original_price = math.multiply(this.original_price_,this.num)
        this.strategy_price = math.multiply(this.strategy_price_,this.num)
        this.vip_strategy_price = math.multiply(this.vip_strategy_price_,this.num)
      }
    },
    // 弹出选择规格弹窗
    goBuy(){
      this.selectSku = true
      if (this.isStrategy1) {
        this.getStategy()
      }
    },
    // 关闭
    closeSelect(){
      this.selectSku = false
    },
    // 获取相关推荐
    getRecomment(){
      var info = {
        lesson_id:this.lesson_id
      }
      lessonRecommendList(info).then((res)=>{
        if(res.errNo==0){
          this.recommendList = res.result
        }
      })
    },
    
    // 评论
    getpl() {
      var params = {
        book_id: this.book_id,
        limit: 1,
        page: 1,
        common_type: 5
      }
      get_evaluate(params)
        .then((res) => {
          if (res.result.list !== undefined) {
            this.pjlist = res.result.list
            console.log(this.pjlist, '评论列表')
          }
          this.comment_num = res.result.count
        })
        .then(() => {
          // this.send()
        })
    },
    // 截取时间
    sli(v) {
      var s = String(v).slice(0, 10)
      return s
    },
    consultTeacher(){
      location.href = this.im_url
    },
    // 获取问答
    getQa() {
      var params = {
        page: 1,
        limit: 2,
        lesson_id: this.book_id,
        type:4
      }
      var _this = this
      QaAll(params).then(res => {
        var reg = /{([\s\S]*?)}/g
        if (res.errNo === 0) {
          res.result.list.forEach((item) => {
            // console.log(item.content)
            if (item.content) {
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          this.QaList = res.result.list
          this.QaCount = res.result.count
        }
      })
    },
    // 跳转全部问答
    go_allQa() {
      this.$router.push({
        path: '/bookQaAll',
        query: {
          // is_buy: this.is_buy ? 1 : 0,
          book_id: this.book_id
        }
      })
    },
    // 跳转全部评论
    go_allComment(){
      this.$router.push({
        path: '/bookCommentAll',
        query: {
          book_id: this.book_id,
          book_name: this.lesson_name
        }
      })
    },
    go_vip() {
      if (this.isToLogin()) {
        location.href=window.origin + `/shop/pay/?product_type=${3}&product_id=${this.book_id}&fromurl=${this.page_url}&f_code=${''}`
        // this.$router.push({
        //   path: '/shop/pay',
        //   query: {
        //     product_type: 3,
        //     product_id: this.lesson_id,
        //     fromurl: `${this.page_url}`
        //   }
        // })
      }
    },
    // 轮播图高亮指示器
    checkActive(index) {
      // console.log(index)
      this.current = index;// current为监听的轮播index
    },
    // 存储每个模块到顶部的高度
    init() {
      setTimeout(() => {
        const anhorTop = document.querySelectorAll('.anhorTop')
        console.log(anhorTop)
        Array.from(anhorTop).map((item) => {
          this.anhorList.push(item.offsetTop - 88) // 减去头部高度
        })
        console.log(this.anhorList)
      }, 200)
    },
    getFun() {
      this.info = ''
      const params = {
        book_id: this.book_id
      }
      getTextbook(params).then(res => {
        if (res.errNo !== 0) {
          return this.$toast(res.msg)
          // this.$message.error(res.result)
        }
        this.loading = false
        const data = res.result
        // 收藏状态
        // this.is_favorite = data.is_favorite
        // 商品规格、套餐
        // this.spec_list = data.spec_list
        // 产品图片
        this.productImg = [data.textbook_info.img]
        this.bigImg = data.textbook_info.img
        // 相关推荐
        // this.recommendList = data.recommend
        // 详情
        this.info = data.textbook_info.info
        // // 购买数、好评率
        // 购买数、好评率
        // this.info_buy_count = data.textbook_statistics.buy_count || 0
        this.info_comment_rate = data.textbook_statistics.comment_rate || 0
        // 名称
        this.lesson_name = data.textbook_info.name
        // vip折扣
        this.vip_discount = data.textbook_info.vip_rate === '' ? 100 : data.textbook_info.vip_rate
        // 最低价格
        this.lessonSpecPrice = data.textbook_info.price
        this.bottom_price = data.textbook_info.price
        this.vip_bottom_price = math.multiply(this.bottom_price, this.vip_discount/100)
        // 是否为vip
        this.vip_level = data.vip_level
        // 图书信息
        this.isbn_number = data.textbook_info.isbn_number
        this.author_name = data.textbook_info.author_name
        this.pages_sum = data.textbook_info.pages_sum
        this.publishing_house = data.textbook_info.publishing_house
        this.publishing_time = data.textbook_info.publishing_time

        // 库存
        this.product_num = data.textbook_info.product_num
        // 联系客服
        this.im_url = data.im_url


        // 销售策略
        const strategy = data.strategy || []
        this.isStrategy = strategy
        if (strategy.length > 0) {
          this.mySpanMsg = strategy[0].id
          this.isStrategy1 = true
        }

        this.getProductPrice(this.bottom_price, this.num, 100)

        if (data.seo) {
          document.title = data.seo.title
          var keywords = document.getElementsByName('keywords')
          var description = document.getElementsByName('description')
          keywords[0]['content'] = data.seo.keywords
          description[0]['content'] = data.seo.description
        }
      }).then(()=>{
        this.init()
        // 动态创建script标签加载视频文件
        var contentList = document.getElementsByClassName('lesson-info')[0].children
        setTimeout(() => {
          for (let i = 0; i < contentList.length; i++) {
            if (contentList[i].innerHTML.includes('/script')) {
              const scriptSrc = contentList[i].lastChild.childNodes[0].src
              const scriptTag = document.createElement('script')
              scriptTag.src = scriptSrc
              contentList[i].lastChild.childNodes[0].appendChild(scriptTag)
            }
          }
        }, 3000)
      })
    },
    // 封装取当前线路相关的规格线路
    getCorrelation(checkId, allSku) { // 第一个参数为当前线路id数组 ，第二个为所有规格线路
      this.spec_list = JSON.parse(JSON.stringify(this.copy_spec_list))
      this.spec_sku = JSON.parse(JSON.stringify(this.copy_spec_sku))
      // console.log(checkId, allSku, '接收参数')
      for (let i = 0; i < allSku.length; i++) {
        allSku[i].intersection = this.intersection(allSku[i].spec_sku_id_arr, checkId)
        // 差集
        allSku[i].diff = this.diff(allSku[i].spec_sku_id_arr, checkId)
      }
      // console.log(allSku, 'allSkuallSku')
      // 找到跟当前规格线路相关且库存为0 的条目
      // 跟当前线路相关规格路线为只有一个规格不同的规格组合
      const correlationData = allSku.filter((item) => {
        return item.intersection.length == checkId.length - 1 && item.num == 0
      })
      // 确定需要禁用规格的按钮位置
      for (let i = 0; i < correlationData.length; i++) {
        // 添加规格位置，disablePosition为当前规格列表所在规格数组的下标
        // disableSpecificationId为当前禁用规格id 所在规格列表的下标
        correlationData[i].disablePosition = correlationData[i].spec_sku_id_arr.indexOf(correlationData[i].diff.join(''))
        correlationData[i].disableSpecificationId = correlationData[i].diff.join('')
      }
      // console.log(correlationData, 'correlationDatacorrelationData')
      // 把产品规格需要禁用的坐标放到渲染页面的规格列表中
      for (let i = 0; i < correlationData.length; i++) {
        // 循环规格列表
        for (let j = 0; j < this.spec_list.length; j++) {
          if (correlationData[i].disablePosition == j) {
            // 循环规格值
            for (let k = 0; k < this.spec_list[j].value.length; k++) {
              if (correlationData[i].disableSpecificationId == this.spec_list[j].value[k].spec_value_id) {
                this.spec_list[j].value[k].disablePosition = correlationData[i].disablePosition
                this.spec_list[j].value[k].disableSpecificationId = correlationData[i].disableSpecificationId
              } else {
                continue
              }
            }
          } else {
            continue
          }
        }
      }
      // console.log(correlationData, '含有库存为0的规格线路')
      // console.log(this.spec_sku)
      // console.log(this.spec_list)
    },
    // 取出一条库存不为0的产品规格 （高亮显示id）
    getDefaultPro(arr,default_id) { // arr为产品规格详细列表 default_id为默认选中的商品规格id
      for (let i = 0; i < arr.length; i++) {
      // 遍历产品规格列表，寻找产品规格中默认选中的产品规格 （高亮显示id） 并将其存储在变量中
        if (arr[i].lesson_sku_id == default_id) {
          //  取当前规格的spec_sku_id默认选中商品，规格高亮
          return {
            defaultId: arr[i].spec_sku_id.split('_'),
            lesson_sku_id: arr[i].lesson_sku_id,
            spec_sku_id: arr[i].spec_sku_id
          }
        }
      }
    },
    // 获取商品价格等信息
    getProductInfo(id) { // id为所选规格线路的lesson_sku_id
      console.log('getProductInfo: ', id) // log.info('getProductInfo: ', this.lesson_info) // log.info('
      var info = {
        lesson_id: this.lesson_id,
        lesson_sku_id: id
      }
      getLessonSpecPrice(info).then((res) => {
        if (res.errNo == 0) {
          console.log(res, '所选商品价格信息')
          const data = res.result
          this.check_lesson_sku_id = data.spec_sku.lesson_sku_id
          this.check_lesson_sku_str = data.spec_sku.spec_sku_id
          this.lessonSpecPrice = data.spec_sku.price
          if(data.spec_sku.img){
            this.bigImg = data.spec_sku.img
          }

          // 拼团
          this.is_groupon = data.is_groupon
          if (data.is_groupon) {
            this.grouponPrice = data.booking.project_price
            // this.lessonSpecPrice = data.booking.project_price
            this.maxNum = data.booking.num
            this.num = this.num > data.booking.num ? data.booking.num : 1
            this.getProductPrice(Number(this.lessonSpecPrice), this.num, 100, data.booking.project_price)
            if (new Date(data.booking.end_time.replace(/-/g, '/')) - new Date() > 0) { // 结束时间大于当前时间
              this.groupTimer = setInterval(() => {
                var timer = new Date(data.booking.end_time.replace(/-/g, '/')) - new Date()
                this.cutTime(timer)
                if (new Date() - new Date(data.booking.end_time.replace(/-/g, '/')) >= 0) { // 当前时间大于结束时间活动结束
                  clearInterval(this.groupTimer)
                  this.groupTimer = null
                  this.reload()
                }
              }, 1000)
            // console.log(timer, 'pppppppp')
            }
          }
          // 限时促销
          // 限时折扣
          this.isZhekou = false
          if (data.flash_sale && data.flash_sale.promotion_id) {
            // this.lessonSpecPrice = data.flash_sale.promotion_price

            // 如果当前时间小于结束时间
            const endTime = data.flash_sale.date_end.toString().replace(/-/g, '/')
            if (new Date(endTime).getTime() > new Date().getTime()) {
              this.isZhekou = true
              this.promotion_rate = data.flash_sale.promotion_rate
              this.promotion_price = data.flash_sale.promotion_price
              const currentGettime = Date.parse(new Date()) / 1000
              if (data.flash_sale.date_begin_time - currentGettime > 0) {
                this.surplusTime = data.flash_sale.date_begin
                this.preorbegin = true             
                // alert(this.preorbegin, 'this.preorbegin')
              } else {
                this.surplusTime = data.flash_sale.date_end
              }
              this.getProductPrice(Number(this.lessonSpecPrice), this.num, this.promotion_rate, this.grouponPrice)
              this.zkTimeFun()
            }
          }
          // 限时免费
          if (data.free && data.free.free_type != 0) {
            this.is_free = true
            // 限时免费活动未开始
            this.maxNum = 1
            this.num = 1
            this.free_type = data.free.free_type
            this.is_free_time = data.free.is_free
            if (this.free_type == 1) {
              this.freeText = data.free.date_begin.slice('5').slice(0, data.free.date_begin.slice('5').length - 3) + '开始'
              console.log(this.freeText)
            } else if (this.free_type == 2 && !this.is_free_time) {
              // 活动进行中且没有领取过
              if (new Date(data.free.date_end.replace(/-/g, '/')) - new Date(data.free.date_begin.replace(/-/g, '/')) > 0) { // 结束时间大于开始时间
                if (new Date(data.free.date_end.replace(/-/g, '/')) - new Date() > 0) { // 结束时间大于当前时间
                  this.free_timer = setInterval(() => {
                    var timer = new Date(data.free.date_end.replace(/-/g, '/')) - new Date()
                    this.freeCutTime(timer)
                    if (new Date() - new Date(data.free.date_end.replace(/-/g, '/')) >= 0) { // 当前时间大于结束时间活动结束
                      this.free_type = 3
                      clearInterval(this.free_timer)
                      this.free_timer = null
                    }
                  }, 1000)
                  // console.log(timer, 'pppppppp')
                }
              }
            }
          } else {
            this.is_free = false
          }
          // 如果没有拼团、折扣、限时免费
          if (!data.is_groupon && !data.flash_sale && !data.free) {
            // 重新计算商品价格
            this.getProductPrice(Number(this.lessonSpecPrice), this.num, 100)
          }
        }
      })
    },
    // 计算产品价格、vip折扣价格、限时折扣价格
    // 产品规格单价 ， 产品数量 默认为1 限时折扣产品 默认为100 不打折， 拼团商品价格，
    getProductPrice(lessonSpecPrice, num = 1, promotion = 100, grouponPrice) {
      // console.log('lessonSpecPrice', lessonSpecPrice, 'num', num, 'promotion', promotion, 'grouponPrice', grouponPrice)
      const promotion_discount = math.divide(promotion, 100)
      // const groupon_discount = math.divide(groupon, 100)
      const vip_discount = math.divide(this.vip_discount, 100)

      // 无套餐（逻辑同未选择套餐）
      // 如果有限时折扣
      if (this.isZhekou) {
        // 如果限时折扣已开始
        if (this.preorbegin) {
          console.log('折扣未开始')
          // 产品价格为
          this.productPrice = math.multiply(lessonSpecPrice, num)
          // 促销价
          this.promotionPrice = math.multiply(this.productPrice, promotion_discount)
          // vip折扣价格为
          this.productVipPrice = math.multiply(this.productPrice, vip_discount)
        } else {
          console.log('折扣已开始')
          // 产品价格为
          this.productPrice = math.multiply(lessonSpecPrice, num)
          // 促销价
          this.promotionPrice = math.multiply(this.productPrice, promotion_discount)
          // vip折扣价格为
          this.productVipPrice = math.multiply(this.promotionPrice, vip_discount)
        }
      }
      // 如果有拼团
      if (this.is_groupon) {
        // 产品价格为
        this.productPrice = math.multiply(lessonSpecPrice, num)
        // 拼团价
        this.promotionPrice = math.multiply(grouponPrice, num)
        // vip折扣价格为
        this.productVipPrice = math.multiply(this.promotionPrice, vip_discount)
      } else if (!this.isZhekou) {
        // 产品价格为
        this.productPrice = math.multiply(lessonSpecPrice, num)
        // 拼团价
        // this.promotionPrice = math.multiply(grouponPrice, num)
        // vip折扣价格为
        this.productVipPrice = math.multiply(this.productPrice, vip_discount)
      }
      console.log(window.location.pathname);
      if(window.location.pathname == '/edu/bookInfo'){
        this.$router.replace({
          path: this.$route.path,
          query: {
            book_id: this.book_id,
            num: this.num
          }
        })
      }
    },
    // 找出商相同的规格id
    // [1,1,3]  [2,3,3] 返回 [3]
    intersection(arr1, arr2) {
      const common = []
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] === arr2[i]) {
          common.push(arr1[i])
        }
      }
      return common
    },
    // 找出商不同的规格id
    // [2,3,3] [2,3,2]返回[2]
    // [1,1,3] [2,3,3]返回[2,3]
    diff(arr1, arr2) {
      const common = []
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          common.push(arr1[i])
        }
      }
      return common
    },
    zkTimeFun() {
      var date = new Date()
      var now = date.getTime()
      // 设置截止时间
      var str = this.surplusTime.toString()
      // console.log(str, '---------------------------------------------')
      var endDate = new Date(str.replace(/-/g, '/'))
      var end = endDate.getTime()
      // 时间差
      var leftTime = end - now
      // console.log(end, now)
      // console.log(leftTime, 'leftTimeleftTime')
      // 定义变量 d,h,m,s保存倒计时的时间
      var d, h, m, s
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24) > 9 ? Math.floor(leftTime / 1000 / 60 / 60 / 24) : '0' + Math.floor(leftTime / 1000 / 60 / 60 / 24)
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24) > 9 ? Math.floor(leftTime / 1000 / 60 / 60 % 24) : '0' + Math.floor(leftTime / 1000 / 60 / 60 % 24)
        m = Math.floor(leftTime / 1000 / 60 % 60) > 9 ? Math.floor(leftTime / 1000 / 60 % 60) : '0' + Math.floor(leftTime / 1000 / 60 % 60)
        s = Math.floor(leftTime / 1000 % 60) > 9 ? Math.floor(leftTime / 1000 % 60) : '0' + Math.floor(leftTime / 1000 % 60)
      } else {
        this.zkTimeFun = null
        this.reload()
        this.isZhekou = false
      }
      this.zhekouDay = d
      this.zhekouHours = h
      this.zhekouMins = m
      this.zhekouSecs = s
      setTimeout(this.zkTimeFun, 1000)
    },
    // 拼团倒计时
    cutTime(timer) {
      var countdown = timer / 1000// 得到相差的描述
      var d = parseInt(countdown / 60 / 60 / 24)
      // d = d < 10 ? '0' + d : d
      var h = parseInt(countdown / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      var m = parseInt(countdown / 60 % 60)
      m = m < 10 ? '0' + m : m
      var s = parseInt(countdown % 60)
      s = s < 10 ? '0' + s : s
      this.groupDay = d
      this.groupHours = h
      this.groupMins = m
      this.groupSecs = s
    },
    go_back() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    },
    focus_ipt(){
      this.$router.push('/searchHistory')
    },
    handleScroll() {
      const top = document.body.scrollTop || document.documentElement.scrollTop
      // console.log(top,'监听滚动')
      let opacity = top / 140
      opacity = opacity > 1 ? 1 : opacity
      this.opacity = opacity
      // 滚动高亮tab
      for (let index = 0; index < this.anhorList.length; index++) {
        if (top < this.anhorList[0]) {
          this.navActive = 0
        }
        if (top > this.anhorList[index] && top < this.anhorList[index + 1]) {
          this.navActive = index
        }
        if (top > this.anhorList[this.anhorList.length - 1]) {
          this.navActive = this.anhorList.length - 1
        }
      }
    },
    asideTap(a) {
      this.$nextTick(() => {
        const index = a
        // this.navActive = index
        const element = document.querySelector('#title' + index) // 返回文档中匹配指定 CSS 选择器的一个元素
        const top = // 网页被卷去的高scrollTop  网页可见区域高：offsetHeight (包括边线的宽);
          element.offsetTop - this.$refs.header.offsetHeight - window.scrollY // scrollY返回文档当前垂直滚动的像素数
        // window.scrollBy({ top, left: 0, behavior: 'smooth' }) // 把内容滚动指定的像素数
        window.scrollBy({ top, left: 0 })
        if(a==0){
          this.opacity = 0
        }else{
          this.opacity = 1
        }
      })  
      window.removeEventListener('scroll', this.handleScroll, false)
      this.navActive = a
      setTimeout(() => {
        window.addEventListener('scroll', this.handleScroll, false)
      }, 1000)
    },
    // 重定向到登录
    isToLogin() {
      var url = encodeURIComponent(location.href)
      if (!Cookies.get('uid') || !Cookies.get('username')) {
        location.href = `/login?redirect=${url}`
        return false
      } else {
        return true
      }
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// 返回按钮
.backBtn{
  position:absolute;
  width: 56px;
  height: 56px;
  top:20px;
  left:20px;
  z-index:1;
}
// 选择规格弹窗
// .van-popup{
//   height:100vh;
// }
/deep/ .van-action-sheet{
  max-height: 100vh;
}
.mainContent{
  height: 100%;
  position:relative;
  padding: 20px;
  box-sizing:border-box;
  .icon-close{
    font-size: 40px;
    font-weight: 600;
    position:absolute;
    top:60px;
    right: 60px;
  }
  .top_product{
    width: 100%;
    display: flex;
    margin-bottom:40px;
    padding-top: 60px;
    .product_left{
      width: 240px;
      height: 240px;
      img{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .product_right{
      flex:1;
      padding:0 0 40px 40px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .product_price{
        color:#ee2e2e;
        font-size: 24px;
        margin-bottom:20px;
        .price{
          font-weight: 600;
          font-size: 36px;
        }
        .unit{
            display: inline-block;
            width:40px;
            font-family: PingFangSC-Medium;
            font-size: 30px;
            letter-spacing: 0;
            font-weight: 500;
            margin-right: 4px;
          }
        .price_bottom{
          display: flex;
          margin-top:10px;
          align-items: center;
          .unit{
            display: inline-block;
            width:40px;
            font-family: PingFangSC-Medium;
            font-size: 30px;
            letter-spacing: 0;
            font-weight: 500;
            margin-right: 4px;
          }
          .money{
            font-size: 36px;
            letter-spacing: 0;
          }
          .vip_discount_price{
              font-size: 28px;
              color: #333333;
              letter-spacing: 0;
              font-weight: 400;
            }
          .vip{
            flex-shrink: 0;
            .vip_status{
                margin-right: 5px;
                z-index:200;
                left:17px;
                top:8px;
                display: flex;
                .is_vip{
                  border-radius: 18px 0 0 18px;
                  font-size: 24px;
                  background: rgba(0, 0, 0, 0.8);
                  // height: 28px;
                  // line-height: 28px;
                  text-align: center;
                  position: relative;
                  left: 14px;
                  // font-weight:600;
                  color: rgba(255,255,255,0.90);
                  padding: 0 10px;
                }
                .discount{
                  color: #4A351E;
                  background-image: linear-gradient(134deg, #F8DAA6 0%, #EABD6D 100%);
                  border-radius:0 18px 18px 0;
                  font-size: 24px;
                  // height: 28px;
                  // line-height: 28px;
                  text-align: center;
                  padding: 0 12px 0 20px;
                  // font-weight:600;
                }
              }
          }
        }
      }
      .discount_price{
        background: #ee2e2e;
        padding: 4px 14px;
        color: #fff;
        font-size:30px;
        width: max-content;
        border-radius: 40px;
        .unit{
          font-size: 24px;
        }
        .price{
          font-weight: 600;
          // font-size: 36px;
        }
      }
      .other_info{
          margin-top: 20px;
          font-size: 24px;
          color:#8D8D8D;
        }
    }
  }
  .product_pack{
    margin-bottom: 20px;
  }
  .product_sku{
    max-height:calc(100vh - 700px);
    padding-bottom: 120px;
    overflow-y: scroll;
    .title{
      font-weight: 800;
      font-size: 32px;
      margin-bottom: 10px;
    }
    .specification_list{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      .specification_item{
        position: relative;
        .product_status{
          position:absolute;
          background: #ee2e2e;
          padding:0px 4px;
          border-radius: 50%;
          color:#fff;
          top: -11px;
          right: 10px;
          font-size:24px;
        }
        .item{
          display: flex;
          align-items: center;
          height: 40px;
          background: #F3F3F3;
          font-family: PingFangSC-Medium;
          font-size: 24px;
          color: #333333;
          letter-spacing: 0;
          font-weight: 400;
          padding:8px 30px;
          border: 1px solid #F3F3F3;
          margin-right: 20px;
          margin-bottom:30px;
          border-radius: 40px;
          cursor:pointer;
          img{
            display: block;
            width: 26px;
            height: 26px;
            margin-right:4px;
          }
        }
        .on{
          background: #FFFFFF;
          border: 1px solid #ee2e2e;
          color:#ee2e2e;
        }
        .disable{
          background: #F5F7FA;
          border: 1px solid #E4E7ED;
          color: #333333;
          cursor: not-allowed;
        }
      }

    }
    .product_num{
      .title{
        margin-bottom: 0;
      }
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .toBuy{
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 38px;
    font-weight: 600;
    position: absolute;
    bottom:0;
    left:0;
    background: #ee2e2e;
    color: #fff;
    border-radius: 12px 12px 0px 0px;
  }
}
// 自定义轮播图指示器样式
.indicators {
  position: absolute;
  bottom: 60px;
  left: 50%;
  display: flex;
  transform: translateX(-50%);
}
.indicator li {
  display:inline;
  width: 36px;
  height: 9px;
  background-color: white;
  // border-radius: 20%;
  opacity: 0.8;
  transition: opacity 0.5s,//@animation-duration-fast
  background-color 0.5s;//@animation-duration-fast

  &:not(:last-child) {
    margin-right: 10px;
  }

  &.active {
    background-color: #000;
    opacity: 1;
  }
}
//@import url(); 引入公共css类
.search_nav{
    height: 120px;
    width: 100%;
    // background: #fff;
    overflow: hidden;
    .book_name{
      margin: 0 auto;
      margin-top: 26px;
      width: 60%;
      text-align: center;
      font-size: 36px;
      text-overflow: ellipsis; /* 溢出显示省略号 */
      overflow: hidden; /* 溢出隐藏 */
      white-space: nowrap;  /* 强制不换行 */
    }
    .go_back {
      float: left;
      width: 40px;
      height:40px;
      margin-left: 16px;
      margin-top: 30px;
    }
    .s_inp{
      width: 60%;
      height: 60px;
      margin-top: 15px;
      margin-left: 20px;
      float: left;
      background:#fff;
      border-radius: 35px;
      margin-right: 10px;
      padding-top: 10px;
      img{
        width: 30px;
        float: left;
        margin-left: 20px;
        margin-top: 12px;
      }
      .s_btn{
        width: 15%;
        text-align: center;
        float: left;
        line-height: 50px;
      }
      input{
        // background:#e8e8e8;
        border: none;
        float: left;
        margin-left: 20px;
        height: 50px;
        width: 70%;
        outline: none;
      }
      input[type=search] {
        -webkit-appearance: textfield;
        -webkit-box-sizing: content-box;
        font-family: inherit;
        font-size: 100%;
        }
        input::-webkit-search-decoration,
        input::-webkit-search-cancel-button {
        display: none;
        }
    }
    .ss_btn{
      float: left;
      width: 13%;
      text-align: center;
      height: 50px;
      margin-top:15px;
      line-height: 50px;
    }
  }
.HSDetail .header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  // height: 0.96rem;
  font-size: 0.3rem;
  color: #050505;
  z-index: 11;
  border-bottom: 0.01rem solid #eee;
  background: #F2F2F2;
}
.top_nav{
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: 20px;
}
.HSDetail .header .item {
  position: relative;
  margin: 0 0.35rem;
  font-size: 28px;
}
.item.on{
  color:#ee2e2e;
}
.HSDetail .header .item.on:before {
  position: absolute;
  width: 0.76rem;
  height: 0.05rem;
  background-repeat: no-repeat;
  content: "";
  background: linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  background: -webkit-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  background: -moz-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  bottom: -0.1rem;
}
.detail_swipe {
  .swipe .van-swipe-item {
    color: #fff;
    font-size: 0.4rem;
    // line-height: 4.08333rem;
    text-align: center;
    img{
      display: block;
      width:100%;
    }
  }
}
.HSDetail {
  .hsd_hande {
    position: fixed;
    width: 100%;
    z-index: 10;
  }
  .hsd_nr {
    position: relative;
    // top: 1.25rem;
    height: 22rem;
    .content:nth-last-child(2) {
      padding-bottom:96px;
    }
  }
}
// 限时折扣
.discountBox,.activity_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ee2e2e;
  padding:20px 40px;
  .activity_left{
    color: #FFFFFF;
    font-weight: 600;
  }
  .activity_right{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .activity_time{
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 500;
      margin-right: 10px;
    }
    .time{
        min-width: 24px;
        padding: 0 4px;
        height: 32px;
        // background: #FFFFFF;
        border-radius: 2px;
        // font-family: PingFangSC-Bold;
        font-size: 36px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height:32px;
        font-weight: 600;
      }
      .symbol{
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 500;
        // margin:0 0px 0 10px;
      }
      // .day{
      //   margin-right: 10px;
      // }
  }
}
// 商品信息
.product_info{
   padding:30px 20px 30px;
  .selling_price{
    margin-bottom:20px;
    .unit{
      display: inline-block;
      width:40px;
      font-family: PingFangSC-Medium;
      font-size: 30px;
      color: #EE2E2E;
      letter-spacing: 0;
      font-weight: 500;
      margin-right: 4px;
    }
    .money{
      font-size: 36px;
      color: #EE2E2E;
      letter-spacing: 0;
      font-weight: 600;
    }
  }
  // vip折扣
  .price_bottom{
    display: flex;
    margin-top:10px;
    align-items: center;
    .unit{
      display: inline-block;
      width:40px;
      font-family: PingFangSC-Medium;
      font-size: 30px;
      letter-spacing: 0;
      font-weight: 500;
      margin-right: 4px;
    }
    .money{
      font-size: 32px;
      letter-spacing: 0;
    }
    .discount_price{
        font-size: 32px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
      }
    .vip{
      flex-shrink: 0;
      .vip_status{
          margin-right: 5px;
          z-index:200;
          left:17px;
          top:8px;
          display: flex;
          .is_vip{
            border-radius: 30px 0 0 30px;
            font-size: 32px;
            background: rgba(0, 0, 0, 0.8);
            // height: 28px;
            // line-height: 28px;
            text-align: center;
            position: relative;
            left: 14px;
            // font-weight:600;
            color: rgba(255,255,255,0.90);
            padding: 0 10px;
          }
          .discount{
            color: #4A351E;
            background-image: linear-gradient(134deg, #F8DAA6 0%, #EABD6D 100%);
            border-radius:0 30px 30px 0;
            font-size: 32px;
            // height: 28px;
            // line-height: 28px;
            text-align: center;
            padding: 0 12px 0 20px;
            // font-weight:600;
          }
        }
    }
  }
  .product_name{
    margin-top: 10px;
    font-size: 32px;
    font-weight: 600;
  }
}
// 评论问答 
.cell{
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size:28px;
  .cell_left{
    .cell_num{
      font-size:24px;
      color:#666;
    }
  }
  .cell_right{
    .feedback{
      margin-right: 20px;
    }
    .arrow-icon{
      color:#666;
    }
  }
  
}
.assess {
  padding: 20px 0;
  margin: 0px 21px 40px 19px;
  font-size: 28px;
  // padding-bottom: 800px;
  // padding-bottom: 180px;
  background: #F9F9F9;
  border-radius: 8px;
  .attrTag{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .attr_item{
      padding: 8px 20px;
      background: #FEE6E2;
      color:#E99D42;
      border-radius: 40px;
      margin:6px 14px;
    }
  }
  .assess-msg {
    width: 100%;
    // margin-top: 20px;
    // border-bottom: #f8f8f8 2px solid;
    min-height: 120px;
    // display: flex;
    // justify-content: space-between;
    .nick {
      padding: 0 13px 0px;
      width: 100%;
      display: flex;
      box-sizing: border-box;
      .nick-img {
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .nick-name {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 11px;
        width: 88%;
        font-size: 28px;
        font-weight: 600;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .comment_content{
      padding-left: 20px;
      padding-top: 10px;
      font-size: 28px;
    }
  }
  
}
// 提问
.qaBox{
  margin: 0px 21px 40px 19px;
  padding: 20px 20px;
  font-size:28px;
  background: #F9F9F9;
  border-radius: 8px;
  .qa-msg{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    .qa_item{
      width: 80%;
      display: flex;
      align-items: center;
      flex:1;
      .qa_content{
        font-size: 30px;
        width:100%;
        // background-color:red;
        /* 关键代码 */
        text-overflow: ellipsis; /* 溢出显示省略号 */
        overflow: hidden; /* 溢出隐藏 */
        white-space: nowrap;  /* 强制不换行 */
        /deep/ img{
          width: 40px;
          height: 40px;
        }
      }
    }
    .qa_num{
      color: #C3C3C3;
      flex-shrink: 0;
    }
    .text{
      font-size:28px;
      font-weight: 600;
      color:rgba(221, 109, 59, 1);
      margin-right: 20px;
    }
  }
}
.qaBox .qa-msg:nth-last-child(2){
  margin-bottom: 0;
  color: #4A351E;
}
.emptyBox {
  width: 100%;
  img {
    width: 150px;
    height: 150px;
    margin: 0 auto;
    display: block;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  p {
    font-size: 28px;
    // font-weight: 600;
    padding-bottom: 20px;
    color: #999;
    text-align: center;
    // padding-top: 30px;
  }
}
// 相关推荐
.recommendBox{
  padding: 0 50px;
  background: #F9F9F9;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 40px;
  .recommendItem{
    width: 190px;
    margin-right: 40px;
    margin-bottom: 40px;
    .imgBox{
      width:100%;
      background: #fff;
      border-radius: 16px;
    }
    .img{
      width: 80%;
      margin:0 auto;
      img{
        display: block;
        width: 100%;
      }
    }
    &:nth-child(3n){
      margin-right: 0;
    }
    .product_name{
      font-size: 28px;
      -webkit-line-clamp: 2;//（用来限制在一个块元素显示的文本的行数，2 表示最多显示 2 行。为了实现该效果，它需要组合其他的 WebKit 属性）
      display: -webkit-box;//（和 1 结合使用，将对象作为弹性伸缩盒子模型显示 ）
      -webkit-box-orient: vertical;//（和 1 结合使用 ，设置或检索伸缩盒对象的子元素的排列方式 ）
      overflow: hidden;//（文本溢出限定的宽度就隐藏内容）
      text-overflow: ellipsis;//（多行文本的情况下，用省略号 “…” 隐藏溢出范围的文本)
    }
    .product_price{
      color:#E36011;
      font-size: 24px;
      .price{
        font-weight: 600;
        font-size: 38px;
      }
    }
  }
}
// 底部固定导航
.bot_nav{
  // padding: 10px 60px;
  width: 100%;
  height: 100px;
  position:fixed;
  bottom:0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  .bot_left{
    width: 50%;
    display: flex;
    align-items: center;
    padding: 10px 60px;
    box-sizing: border-box;
    .left-advice,.right-like{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 60px;
      p{
        font-size: 24px;
      }
      img{
        width:40px;
        height: 40px;
      }
    }
  }
  .bot_right{
    height: 100%;
    width: 50%;
    .goBuy,.have_none{
      height: 100%;
      width: 100%;
      color:#ffff;
      background: #ee2e2e;
      line-height: 100px;
      text-align: center;
      font-size:28px;
      // padding:12px 24px;
    }
    .have_none{
      background-color: rgba(164, 173, 179, 1);
    }
  }
}
// 分类标题
.itemTitle{
  // width:200%;
  font-size: 32px;
  color:#8E8E8E;
  text-align: center;
  padding:40px 0;
  // transform: scale(0.5);
  .line{
    font-size: 20px;
  }
}
// 详情
.lesson-info /deep/ img {
  display: block;
  width: 100% !important;
  min-height: 100%;
  -webkit-user-drag: none;
}
.lesson-info /deep/ span {
  display: block;
  width: 100% !important;
  -webkit-user-drag: none;
}
.lesson-info {
  position: relative;
  margin-bottom: 250px;
  // font-size:0;
  p {
    margin: 0;
    padding: 0;
  }
}
// loading动画
.loadingBox{
  width: 100vw;
  height:100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.6);
  position: fixed;
  z-index: 100;
  top:0;
  left:0;
}
.loader {
  --size-loader: 80px;
  --size-orbe: 10px;
  width: var(--size-loader);
  height: var(--size-loader);
  position: relative;
  transform: rotate(45deg);
}

.orbe {
  position: absolute;
  width: 100%;
  height: 100%;
  --delay: calc(var(--index) * 0.1s);
  animation: orbit7456 ease-in-out 1.5s var(--delay) infinite;
  opacity: calc(1 - calc(0.2 * var(--index)));
}

.orbe::after {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: var(--size-orbe);
  height: var(--size-orbe);
  background-color: #0094ff;
  box-shadow: 0px 0px 20px 2px #0094ff;
  border-radius: 50%;
}

@keyframes orbit7456 {
  0% {
  }

  80% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.product_desc{
  // padding:20px;
  // border-bottom: 1px solid #f5f5f5;
  font-size: 24px;
  margin-bottom:20px;
  .row{
    display: flex;
    // align-items: center;
    margin-bottom:10px;
    div{
      width: 50%;
    }
  }
  .row:last-child{
    margin-bottom:0px;
  }
}
.mySpans {
  .span1 {
    border: 1px solid rgba(237,61,62,1);
    background: #FBEBEB;
    // color: #ee2e2e;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #ED3D3E;
    letter-spacing: 0;
    font-weight: 500;
  }
  span {
    display: inline-block;
    cursor: pointer;
    text-align: center;
    min-width: 200px;
    background: #f1f1f1;
    border: 1px solid #f1f1f1;
    border-radius: 40px;
    padding: 8px 15px;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    margin: 10px;
  }
}
</style>